// extracted by mini-css-extract-plugin
module.exports = {"btn":"FileUploadInStorage_btn__27oah","container":"FileUploadInStorage_container__6syKF","input":"FileUploadInStorage_input__1Udwy"};